import { UAParser } from 'ua-parser-js';
import { consoleLogger } from '../../constants/console-logger';
import { DeviceInfo } from '../../device-api/device-info';
export class BrowserInfo extends DeviceInfo {
    context;
    constructor(cache, context) {
        super(cache);
        this.context = context;
        this.parseUserAgent(this.context.navigator.userAgent);
        this.deviceType = 'DESKTOP';
        this.deviceManufacturer = this.context.navigator.vendor; // 'Google Inc.'
        this.deviceBrand = this.context.navigator.vendor; // 'Google Inc.'
        this.deviceModel = this.context.navigator.platform; // 'MacIntel'
        this.deviceVersion = this.context.navigator.userAgent; // 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/79.0.3945.79 Safari/537.36'
        this.userFriendlyName = this.context.navigator.appName; // 'Netscape'
    }
    parseUserAgent(userAgent) {
        const parser = new UAParser(userAgent);
        const browser = parser.getBrowser();
        const os = parser.getOS();
        this.browserName = browser.name || '';
        this.browserVersion = browser.version || '';
        this.operatingSystemName = os.name || '';
        this.setOperatingSystemVersion(os.version || '');
    }
    async setOperatingSystemVersion(version) {
        this.operatingSystemVersion = version;
        if (this.context.navigator.userAgentData) {
            try {
                const uaData = await this.context.navigator.userAgentData.getHighEntropyValues(['platformVersion']);
                if (uaData.platform === 'Windows') {
                    const majorPlatformVersion = parseInt(uaData.platformVersion.split('.')[0], 10);
                    if (majorPlatformVersion >= 13) {
                        this.operatingSystemVersion = '11';
                    }
                }
            }
            catch (error) {
                const errorString = error ? error.toString() : 'unknown reason';
                consoleLogger.warn(`Error calling getHighEntropyValues: ${errorString}`);
            }
        }
    }
}
//# sourceMappingURL=browser-info.js.map